import { render } from "./TestiComp.vue?vue&type=template&id=5ba4f23a&scoped=true"
import script from "./TestiComp.vue?vue&type=script&lang=js"
export * from "./TestiComp.vue?vue&type=script&lang=js"

import "./TestiComp.vue?vue&type=style&index=0&id=5ba4f23a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba4f23a"]])

export default __exports__